import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { alertModal } from '../utils/modalController';
import styles from './AddPatientResponse.module.scss';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';

interface AddPatientResponseProps {
    formId?: number;
}

const AddPatientResponse: React.FC<AddPatientResponseProps> = ({ formId }) => {

    const [forms, setForms] = useState<Form[]>([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        fetchAuth(apiUrl + '/consultorio/forms') // ajuste aqui seu endpoint real
            .then(async (response) => {
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Erro na resposta da API: ${response.status} - ${errorText}`);
                }
                return response.json();
            })
            .then((json) => {
                setForms(json);
            })
            .catch((err) => {
                console.error('Erro ao buscar forms:', err);
                alertModal('Erro ao buscar forms: ' + err);
                setForms([]); // fallback
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <>
            <Form.Control
                type="hidden"
                name="id"
                value={formId || ''}
            />
            <Form.Group>
                <Form.Label htmlFor="form">Formulário</Form.Label>
                <Select
                    options={forms.map((form) => ({
                        value: form.id,
                        label: form.title,
                    }))}
                    classNames={
                        {
                            control: (state) => `${styles['select-control']} ${state.isFocused ? styles['focused'] : ''}`,
                            menu: () => styles['select-menu'],
                            option: (state) => `${styles['select-option']} ${state.isSelected ? styles['selected'] : ''}`,
                            container: () => styles['select-container'],
                        }
                    }
                    isSearchable={true}
                    placeholder="Selecione um formulário"
                    id="form"
                    name="form"
                    required={true}
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    isDisabled={isLoading}
                />
            </Form.Group>
            <Form.Group>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Check
                            type="switch"
                            label="Permitir múltiplas respostas"
                            id="multiple_responses"
                            name="multiple_responses"
                            defaultChecked={false}
                            disabled={isLoading}
                            className={styles['switch']}
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Check
                            type="switch"
                            label="Incluir campos de cadastro"
                            id="show_config_fields"
                            name="show_config_fields"
                            defaultChecked={false}
                            disabled={isLoading}
                            className={styles['switch']}
                        />
                    </Col>
                </Row>
            </Form.Group>
        </>
    );
};

export default AddPatientResponse;
